import { getDefaultRequestState } from '@Features/utils/getDefaultRequestState';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RequestFormHeader } from '@Types/index';

interface ResumptionRequestState {
  resumptionRequest: RequestFormHeader;
}

const initialState: ResumptionRequestState = {
  resumptionRequest: getDefaultRequestState(),
};

const resumptionRequestSlice = createSlice({
  name: 'resumptionRequest',
  initialState,
  reducers: {
    setResumptionRequest: (
      state: ResumptionRequestState,
      action: PayloadAction<RequestFormHeader | null>
    ) => {
      const { payload } = action;

      if (payload === null) {
        state.resumptionRequest = getDefaultRequestState();
      } else {
        state.resumptionRequest = payload;
      }
    },
  },
});

const { actions } = resumptionRequestSlice;

export const resumptionRequestActions = {
  ...actions,
};

export default resumptionRequestSlice;
